import { render, staticRenderFns } from "./editFreezeReason.vue?vue&type=template&id=9d51223c"
import script from "./editFreezeReason.vue?vue&type=script&lang=js"
export * from "./editFreezeReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports